export { default } from './dialog'
export { default as DialogInner } from './dialog-inner'
export { default as DialogFooter } from './dialog-footer'
export { default as DialogFooterActionsBar } from './dialog-footer-actions-bar'
export type { Props as DialogProps } from './dialog'
/* Using a dialog? Make sure you import `dialog-globals.scss` in your `_app.js`. */
